// this whole file is bonkers, i dont dare to touch it. do we still need this?
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import { IPartialBlockFactory } from './IPartialBlockFactoryinterfaces';
import { getBlockComponent } from '../../../lib/BlockUtils/BlockUtils';
import validOn2PartialBlocks from '../validOn2PartialBlocks';

type PartialBlockPortalFactoryProps = IPartialBlockFactory & {
  ref: React.RefObject<HTMLDivElement | null>;
};

function PartialBlockPortalFactory({
  identifier,
  partialBlocks,
  partialBlockSelector,
  partialBlockSelectorKeyPlaceHolder,
  replaceIdentifier,
  ref,
}: PartialBlockPortalFactoryProps) {
  if (!ref.current) {
    return null;
  }

  // cast needed to be able to use querySelector
  const wrapper = ref.current.querySelector(
    partialBlockSelector.replace(partialBlockSelectorKeyPlaceHolder, identifier)
  );

  if (!wrapper) {
    return null;
  }

  const redundantElement = wrapper.querySelector(`[${replaceIdentifier}]`);
  if (redundantElement) {
    wrapper.removeChild(redundantElement);
  }

  return ReactDOM.createPortal(getBlockComponent(validOn2PartialBlocks)(partialBlocks[identifier]), wrapper);
}

export default PartialBlockPortalFactory;
